import React from "react";
import styles from "./index.module.css";
import Image from "next/image";

import { imageScale } from "@/utils/motion";
import { useInView } from "react-intersection-observer";
import { AnimatePresence, motion } from "framer-motion";

import { GilroyFontDark, GilroyFontLight } from "@lib/GilroyFont";

const Section02 = ({ data }) => {
  const [ref, inView] = useInView({
    triggerOnce: true, // This means the animation will trigger only once when it comes into view
    threshold: 0.1, // Percentage of the component's visibility, adjust as needed
  });

  const animation = inView ? imageScale(1.5).animate : imageScale(0.5).initial;

  return (
    <div ref={ref} className="min-h-screen">
      <AnimatePresence>
        {inView && (
          <motion.div initial={imageScale(0.5).initial} animate={animation}>
            <div className="flex flex-col items-start pt-[4rem] px-[0.5rem] sm:px-[2.5rem] max-w-[90rem] m-auto">
              <div className="sm:flex items-start text-white">
                <div className="min-w-[60%] pt-[4rem]">
                  {/* <h2 className={styles.heading_about_us} >Learn More</h2> */}
                  <h3
                    className={` text-[36px] sm:text-[65px] text-white ${GilroyFontDark.className} `}
                    dangerouslySetInnerHTML={{ __html: data?.a2_first_heading }}
                  ></h3>
                  <div className="sm:w-[80%] h-auto sm:h-[80%] text-white">
                    <p
                      className={` ${GilroyFontLight.className} ${styles.paragraph_styles}  `}
                    >
                      {data?.a2_first_paragraph}
                    </p>
                  </div>
                </div>
                <div className="min-w-[40%] sm:max-w-[40%] ">
                  <Image
                    alt={data?.a2_first_image_alt}
                    style={{ aspectRatio: "2/3", objectFit: "contain" }}
                    className="min-h-[100%]"
                    responsive
                    width={500}
                    height={500}
                    src={data?.a2_first_image}
                  />
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Section02;
